import React from "react";
import useRegion from "../../../../hooks/super/useRegion";
import { ConfirmModal } from "../../../../components/pages/_new/super/design";

function RestoreRegionModal({ open, handleClose, id, name }) {
  const { restoreRegion } = useRegion();
  const [busy, setBusy] = React.useState(false);

  const onConfirm = async () => {
    if (busy) return;
    setBusy(true);
    try {
      await restoreRegion(id);
      handleClose();
    } finally {
      setBusy(false);
    }
  };

  return (
    <ConfirmModal
      open={open}
      onClose={handleClose}
      onConfirm={onConfirm}
      variant="success"
      title="Restore region?"
      body="The WAF endpoint will be restored to active status."
      items={id ? [{ id, title: name }] : []}
      submitLabel="Restore"
      loading={busy}
    />
  );
}

export default RestoreRegionModal;
